import {CircleStyles} from './SVGCircles';

export enum LayoutCircleType {
  BLUE = 'blue',
  BLUE_BRIGHT = 'blueBright',
  DARK = 'dark',
  MEDIUM = 'medium',
  LIGHT = 'light',
  YELLOW = 'yellow',
  YELLOW_BRIGHT = 'yellowBright',
}

export interface LayoutCircleProps {
  style: CircleStyles;
  imgUrl?: string;
  type: LayoutCircleType;
  isSolid?: boolean;
  multiple?: {
    rows: number;
    columns: number;
  };
}

export interface LayoutCircleConfig {
  desktop?: LayoutCircleProps[];
  tablet?: LayoutCircleProps[];
  mobile?: LayoutCircleProps[];
  allDevices?: LayoutCircleProps[];
}
